import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["type", "percentFields", "fixedFields", "duration", "durationMonths"]

  connect() {
    this.refresh()
  }

  refresh() {
    this.toggleFields(this.percentFieldsTarget, this.typeTarget.value === "percent")
    this.toggleFields(this.fixedFieldsTarget, this.typeTarget.value === "fixed_amount")
    this.toggleFields(this.durationMonthsTarget, this.durationTarget.value === "repeating")
  }

  toggleFields(container, visible) {
    container.classList.toggle("hidden", !visible)
    container.querySelectorAll("input").forEach((input) => {
      input.disabled = !visible
    })
  }
}
